"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFamilyPageStates = void 0;
var EFamilyPageStates;
(function (EFamilyPageStates) {
    EFamilyPageStates["LISTING"] = "Listing";
    EFamilyPageStates["COMPARE"] = "Compare";
})(EFamilyPageStates = exports.EFamilyPageStates || (exports.EFamilyPageStates = {}));
